var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCookingOil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 96 96",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cooking_oil",
    "data-name": "Cooking oil"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m59.83 68.67a2.54 2.54 0 0 1 -2.54 2.54h-25.17a2.55 2.55 0 0 1 0-5.09h25.17a2.54 2.54 0 0 1 2.54 2.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.42 68.67a2.54 2.54 0 0 1 -2.54 2.54h-2.83a4.52 4.52 0 0 0 0-5.09h2.84a2.55 2.55 0 0 1 2.53 2.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.83 73.75a2.55 2.55 0 0 1 -2.54 2.55h-25.17a2.55 2.55 0 0 1 0-5.1h25.17a2.55 2.55 0 0 1 2.54 2.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.42 73.75a2.55 2.55 0 0 1 -2.54 2.55h-2.83a4.54 4.54 0 0 0 0-5.1h2.84a2.55 2.55 0 0 1 2.53 2.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.83 78.84a2.54 2.54 0 0 1 -2.54 2.54h-25.17a2.55 2.55 0 0 1 0-5.09h25.17a2.54 2.54 0 0 1 2.54 2.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.42 78.84a2.54 2.54 0 0 1 -2.54 2.54h-2.83a4.52 4.52 0 0 0 0-5.09h2.84a2.55 2.55 0 0 1 2.53 2.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.42 92.22a2.77 2.77 0 0 1 -2.77 2.78h-2.17a3.39 3.39 0 0 0 .35-1.52 1 1 0 0 0 -2 0 1.53 1.53 0 0 1 -1.33 1.52h-26.15a2.77 2.77 0 0 1 -2.77-2.77c0-8.79-.12-8.56.34-9.41a4.53 4.53 0 0 0 2.2.57h31.76a4.54 4.54 0 0 0 2.2-.57c.45.83.34.51.34 9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.14 40.33c-1.3.78-2.33.62-4.36.62.07.32 0-.21 0 8.84a1 1 0 1 1 -2 0c0-9.06 0-8.5-.1-8.84h-27.56a4.38 4.38 0 0 1 -2.26-.62c-.4.78-.28-.82-.28 23.25a2.6 2.6 0 0 0 .27 1.15 4.44 4.44 0 0 1 2.27-.61h31.76a4.38 4.38 0 0 1 2.26.62c.4-.78.28.82.28-23.25a2.52 2.52 0 0 0 -.28-1.16zm-18.14 20.29a6.31 6.31 0 0 1 -6.3-6.3c0-3.26 4.48-8.8 6.3-11.11 1.9 2.41 6.3 7.87 6.3 11.11a6.31 6.31 0 0 1 -6.3 6.3zm13.83-4.08a1 1 0 1 1 -2 0v-2a1 1 0 0 1 2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.83 36.41a2.54 2.54 0 0 1 -2.54 2.59h-25.17a2.55 2.55 0 0 1 0-5.09h25.17a2.54 2.54 0 0 1 2.54 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.42 36.41a2.54 2.54 0 0 1 -2.54 2.59h-2.83a4.52 4.52 0 0 0 0-5.09h2.84a2.55 2.55 0 0 1 2.53 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.15 19.2-6.8-5.78h-4l5.9 5a1 1 0 1 1 -1.33 1.58l-7.69-6.54h-7.58l-6.8 5.78a12.13 12.13 0 0 0 -4.27 9.24c0 2.39-.12 3.13.34 4a4.53 4.53 0 0 1 2.2-.57h27.53c.26-.49.18-.78.18-3.42a10.76 10.76 0 0 0 -.26-2.4 1 1 0 0 1 2-.43 12.85 12.85 0 0 1 .31 2.83 19.7 19.7 0 0 1 -.08 3.42c2.08 0 3-.14 4.33.57a2.83 2.83 0 0 0 .34-1.34v-2.7a12.13 12.13 0 0 0 -4.32-9.24zm-22 1.17-3.06 2.63a7.16 7.16 0 0 0 -2.09 3.16 1 1 0 1 1 -1.9-.64c1-2.93 2.81-4.09 5.83-6.67a1 1 0 0 1 1.3 1.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 9.42h10v2h-10z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6.42,
    rx: 1.48,
    width: 13.17,
    x: 41.42,
    y: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.3 54.32a4.3 4.3 0 0 1 -8.6 0c0-2.37 4.3-7.87 4.3-7.87s4.3 5.55 4.3 7.87z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookingOil);
export default __webpack_public_path__ + "static/media/cooking-oil.8caabc6d150ab1687eae4120e7ca52f7.svg";
export { ForwardRef as ReactComponent };